// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form from "../Restaumatic.Form/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
var Action = function (x) {
    return x;
};
var trigger = function (v) {
    return function (param) {
        return function __do() {
            var e = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(Specular_Ref.value(v.effect))();
            return Specular_Callback.triggerCallback(e)(param)();
        };
    };
};
var triggerCb = function (a) {
    return trigger(a);
};
var trigger_ = function (a) {
    return trigger(a)(Data_Unit.unit);
};
var makeEmptyAction = {
    makeEmptyImpl: function (v) {
        return function __do() {
            var effect1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Data_Monoid.mempty(Data_Monoid.monoidFn(Effect.monoidEffect(Data_Monoid.monoidUnit))))();
            return {
                effect: effect1
            };
        };
    }
};
var effect = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(Restaumatic_Form.monadEffectFormDefM)(Restaumatic_Form.writeRef(v1.effect)(Specular_Callback.mkCallback(v)));
    };
};
var effect_ = function ($9) {
    return effect(Data_Function["const"]($9));
};
var dumpStateAction = {
    dumpState: function (v) {
        return Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordNil))({}));
    }
};
var addContextAction = {
    addContext: function (v) {
        return function (v1) {
            return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
        };
    }
};
export {
    Action,
    effect,
    effect_,
    trigger,
    trigger_,
    triggerCb,
    makeEmptyAction,
    addContextAction,
    dumpStateAction
};
//# sourceMappingURL=index.js.map
